import { gql } from "@apollo/client";

export const classroomsAvailabilities = gql`
  query classroomsAvailabilities($originId: ID!, $scenarioId: ID!, $filter: ClassroomFilterInput!) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      classroomsAvailabilities(filter: $filter) {
        items {
          id
          code
          name
          floor
          capacity
          usable
          isSpecialTagValue
          classroomType {
            id
            name
            code
          }
          assignment {
            usagePercentage
            chairsOccupationPercentage
          }
          building {
            id
            name
            code
            campus {
              id
              name
              code
            }
          }
        }
        pageInfo {
          hasPreviousPage
          hasNextPage
          page
          size
          total
        }
      }
    }
  }
`;
